import React, { useState, useCallback } from "react";
import Autosuggest from "react-autosuggest";
import { connect } from "react-redux";
import { actions } from "../modules/market";
import qs from "qs";
import _ from "lodash";

const getSuggestionValue = suggestion => suggestion.name;
const renderSuggestion = suggestion => (
  <ul className="list-group list-group-flush selectable">{suggestion.name}</ul>
);

const container = connect(
  state => ({
    dealer: state.dealers.currentDealer,
    categories: state.market.categories
  }),
  {
    fetchCategories: actions.fetchCategories
  }
);

const CategoriesAutoSuggest = container(
  ({ fetchCategories, dealer, categories, onSuggestionSelected }) => {
    const [value, setValue] = useState("");
    const dealer_id = _.get(dealer, "id", "");
    const onSuggestionsFetchRequested = useCallback(
      ({ value }) => {
        fetchCategories({
          dealer_id: dealer_id,
          query: qs.stringify({ name: value }, { addQueryPrefix: true })
        });
      },
      [fetchCategories, dealer_id]
    );
    const onSuggestionsClearRequested = () => {};

    const onChange = useCallback(
      (ev, { newValue }) => {
        setValue(newValue);
      },
      [setValue]
    );
    const inputProps = {
      placeholder: "Search Category",
      value,
      onChange,
      className: "form-control"
    };
    return (
      <Autosuggest
        suggestions={categories}
        onSuggestionSelected={(ev, data) => {
          setValue("");
          onSuggestionSelected(ev, data);
        }}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
);

CategoriesAutoSuggest.displayName = "CategoriesAutoSuggest";

export default CategoriesAutoSuggest;
